/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';
import Alert from '../Alert';
import BaseCom from '../BaseCom';

export default class PaymentLayout extends BaseCom {

  render() {
    return (
      <div className="payment">
        <Outlet />
      </div>
    );
  }
}
